class Header
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'header--bound'
            @.$burgerButton = @.$el.querySelector '.header__menu-button'
            @.$links = @.$el.querySelectorAll 'a'

            @.menuOpen = false
            @.lastPageScroll = 0
        
            @.$el.classList.add 'header--bound'
            @.InitEvents()
            @.ToggleFixedState()
        return

    CloseHeader: ->
        document.getElementById('site').classList.remove 'header-open'
        # reset page scroll
        document.getElementById('content').style.removeProperty "transform"
        window.scrollTo 0, @.pageLastScroll
        return

    InitEvents: ->
        self = @
        @.$burgerButton.addEventListener 'click', (e) ->
            self.ToggleHeaderOpen()
            return
        @.$links
            .forEach (link) ->
                if link.dataset.closeHeader
                    link.addEventListener 'click', (e) ->
                        self.$burgerButton.click()
                        return
                return
            
        document.addEventListener 'scroll', (e) ->
            self.ToggleFixedState()
            return
        return

    OpenHeader: ->
        # save page last scroll position and fix page
        @.pageLastScroll = window.scrollY
        document.getElementById('site').classList.add 'header-open'
        document.getElementById('content').style.transform = "translateY(-" + @.pageLastScroll + "px)"
        return
    
    ToggleHeaderOpen: ->
        @.$el.classList.toggle 'header--open'
        @.$burgerButton.setAttribute 'aria-hidden', (!@.menuOpen).toString()
        @.menuOpen = @.$el.classList.contains('header--open')
        if @.menuOpen
            @.OpenHeader()
        else
            @.CloseHeader()
        return
    
    ToggleFixedState: ->
        if window.scrollY > 35
            @.$el.classList.add 'header--fixed'
        else
            if !document.getElementById('site').classList.contains('overlay-open')
                @.$el.classList.remove 'header--fixed'
        return

BindHeaders = ->
    document.querySelectorAll '.header:not(.header--bound)'
        .forEach (el) ->
            new Header el
            return
    return

window.addEventListener 'bind-components', BindHeaders